import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Adapts backend stats to the shape CabinDashboard / CabinProgress expect.
 * Backend: { total_xp, total_miles, current_level, today_xp, today_miles,
 *            completed_today, weekly_chart:[{date,completed}], streak:{current,longest} }
 * Frontend expects: { totalMiles, streak, completedLessons, level, overallProgress,
 *                     totalLessons, todayXp, todayMiles, weeklyActivity, ... }
 */
function adaptStats(s) {
  // weekly_chart â†’ weeklyActivity (keep both shapes for compatibility)
  const weeklyActivity = (s.weekly_chart || s.weeklyActivity || []).map((item) => ({
    date: item.date,
    day: item.day || '',
    day_en: item.day_en || '',
    miles: item.miles ?? item.completed ?? 0,
    completed: item.completed ?? 0,
  }));

  return {
    // primary fields used by CabinDashboard
    totalMiles: s.total_miles ?? s.totalMiles ?? 0,
    streak: s.streak?.current ?? s.streak ?? 0,
    streakLongest: s.streak?.longest ?? 0,
    completedLessons: s.completed_lessons ?? s.completedLessons ?? 0,
    completedToday: s.completed_today ?? 0,
    level: s.current_level !== undefined ? `L${s.current_level}` : (s.level || '—'),
    current_level: s.current_level ?? 0,
    overallProgress: s.overall_progress ?? s.overallProgress ?? 0,
    examEligible: s.exam_eligible ?? false,
    totalLessons: s.total_lessons ?? s.totalLessons ?? 309,
    todayXp: s.today_xp ?? s.todayXp ?? 0,
    todayMiles: s.today_miles ?? s.todayMiles ?? 0,
    totalXp: s.total_xp ?? s.totalXp ?? 0,
    // weekly chart
    weeklyActivity,
    weekly_chart: s.weekly_chart || [],
    // skills (not in backend stats yet)
    skills: s.skills || [],
    recentActivity: s.recentActivity || [],
    // keep raw fields too
    levelName_tr: s.levelName_tr || '',
    levelName_en: s.levelName_en || '',
  };
}

async function fetchCabinStats() {
  const token = getToken();
  const res = await axios.get(`${API}/cabin/stats`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return adaptStats(res.data);
}

export function useCabinStats() {
  return useQuery({
    queryKey: ['cabin', 'stats'],
    queryFn: fetchCabinStats,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: typeof window !== 'undefined' && !!getToken(),
  });
}
